module.exports = "/static/assets/cb317a2b69045c85ab5eedc7b65ecbcd.png";